import React from "react";

import { priceList } from "../../../../data/communications";
import RightBar from "../../../../components/common/RightBar";

import { Button, Card, Col, Row } from "antd";

import mail_1 from "../../../../assets/images/mail1.svg";
import mail_2 from "../../../../assets/images/mail2.svg";
import mail_3 from "../../../../assets/images/mail3.svg";
import feature_1 from "../../../../assets/images/feature1.svg";
import feature_2 from "../../../../assets/images/feature2.svg";
import feature_3 from "../../../../assets/images/feature3.svg";
import feature_4 from "../../../../assets/images/feature4.svg";
import feature_5 from "../../../../assets/images/feature5.svg";
import feature_6 from "../../../../assets/images/feature6.svg";
import feature_7 from "../../../../assets/images/feature7.svg";
import step_1 from "../../../../assets/images/step1.svg";
import step_2 from "../../../../assets/images/step2.svg";
import step_3 from "../../../../assets/images/step3.svg";
import step_4 from "../../../../assets/images/step4.svg";

import "./MailingServices.css";

const MailingServicesRightBar = [];

function MailingServices() {
  return (
    <>
      <div className="mailing-service">
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <Card title="Core Benefits">
              <div className="core-benefits-container">
                <div className="benefits-container">
                  <div className="mail-container">
                    <img src={mail_1} alt="image" />
                    <p>Easily send and track mail to homeowners in AppFolio.</p>
                  </div>
                  <div className="mail-container">
                    <img src={mail_2} alt="image" />
                    <p>
                      Use staff's time more efficiently. Say goodbye to manually
                      printing, stuffing, and stamping letters.
                    </p>
                  </div>
                  <div className="mail-container">
                    <img src={mail_3} alt="image" />
                    <p>
                      Deliver outstanding experiences with professional looking
                      and timely mail.
                    </p>
                  </div>
                </div>
                <div className="action-container">
                  <Button disabled={true}>Signup</Button>
                  <Button>Learn More</Button>
                </div>
                <p className="silver-text para-text">
                  You must be a presidential user to sign-up.
                </p>
              </div>
            </Card>
          </Col>
          <Col span={24}>
            <Card title="Key Features">
              <div className="key-features-container">
                <div className="mail-container">
                  <img src={feature_1} alt="image" />
                  <p>
                    Mail letters to a single homeowner or an entire association.
                  </p>
                </div>
                <div className="mail-container">
                  <img src={feature_2} alt="image" />
                  <p>
                    Include AppFolio letter templates, statements, and/or PDFs.
                  </p>
                </div>
                <div className="mail-container">
                  <img src={feature_3} alt="image" />
                  <p>Print your letters in black & white or color ink.</p>
                </div>
                <div className="mail-container">
                  <img src={feature_4} alt="image" />
                  <p>Print your letters single or double-sided.</p>
                </div>
                <div className="mail-container">
                  <img src={feature_5} alt="image" />
                  <p>Send your mail Certified.</p>
                </div>
                <div className="mail-container">
                  <img src={feature_6} alt="image" />
                  <p>Preview a sample letter before sending.</p>
                </div>
                <div className="mail-container">
                  <img src={feature_7} alt="image" />
                  <p>
                    Letters are typically mailed within 2 to 3 business days..
                  </p>
                </div>
              </div>
            </Card>
          </Col>
          <Col span={24}>
            <Card title="Streamlined and Easy-to-Use">
              <div className="steps-container">
                <div className="mail-container">
                  <img src={step_1} alt="image" />
                  <strong>Step 1</strong>
                  <p>Select a violation, homeowner, or an association.</p>
                </div>
                <div className="mail-container">
                  <img src={step_2} alt="image" />
                  <strong>Step 2</strong>
                  <p>Choose your documents and mail preferences.</p>
                </div>
                <div className="mail-container">
                  <img src={step_3} alt="image" />
                  <strong>Step 3</strong>
                  <p>Review the cost and preview a sample letter.</p>
                </div>
                <div className="mail-container">
                  <img src={step_4} alt="image" />
                  <strong>Step 4</strong>
                  <p>Submit your letters to be mailed in a single click.</p>
                </div>
              </div>
            </Card>
          </Col>
          <Col span={24}>
            <Card title="Pricing">
              <Row className="header-row">
                <Col span={18} className="header-col">
                  <span>Pricing (per letter)</span>
                </Col>
                <Col span={6} className="header-col">
                  <span>Current Cost</span>
                </Col>
              </Row>
              {/* {priceList.map((item, index) => {
                return (
                  <Row className="data-row" key={index}>
                    <Col span={18} className="data-col">
                      <span>{item.letter}</span>
                    </Col>
                    <Col span={6} className="data-col">
                      <span>{item.currentCost}</span>
                    </Col>
                  </Row>
                );
              })} */}
            </Card>
          </Col>
        </Row>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={MailingServicesRightBar} />
      </div>
    </>
  );
}

export default MailingServices;
